/* @flow */

//----------------------------------------------------------------------//
//                         Imported NPM modules                         //
//----------------------------------------------------------------------//

import * as React from 'react';
import { observer } from 'mobx-react';
import NumberFormat from 'react-number-format';

//----------------------------------------------------------------------//
//                     Imported app modules/assets                      //
//----------------------------------------------------------------------//

import TextField from '@material-ui/core/TextField';

import styles from './ElectroNumberField.module.scss';

//----------------------------------------------------------------------//
//                       Exported React component                       //
//----------------------------------------------------------------------//

type TypeProps = {|
  field: Object,
  disabled?: boolean,
|};

const onChange = field => e => {
  e.preventDefault();
  field.set(field.value);
};

const ElectroNumberField: React.StatelessFunctionalComponent<*> = ({
  field,
  disabled,
  ...other
}: TypeProps) => (
  <div className={styles['electro-number-field']}>
    <NumberFormat
      {...field.bind({ onChange: onChange(field) })}
      // Material UI props
      customInput={TextField}
      error={field.showError && field.hasError}
      helperText={
        field.showError && field.error
          ? field.error
          : field.extra && field.extra.helperText
          ? field.extra.helperText
          : ''
      }
      required={field.rules && field.rules.includes('required')}
      disabled={disabled}
      margin="none"
      // NumberFormat default props
      onValueChange={(obj: Object) => {
        field.set(obj.floatValue || null);
      }}
      prefix="$"
      thousandSeparator=","
      decimalSeparator="."
      decimalScale={2}
      // Overwrite current props
      {...other}
    />
  </div>
);

export default observer(ElectroNumberField);
